import styled from 'styled-components'

export const Entry = styled.span`
	white-space: nowrap;
`
